export default __webpack_public_path__ + "static/media/overview1.316f8bb7.png";